import type React from 'react';
import { useTranslation } from 'react-i18next';
import { TbError404 } from 'react-icons/tb';
import { ROUTES } from '../../../constants/Constants';
import useAppNavigation from '../../../hooks/useAppNavigation';
import type { AppSsrFetchedDataType } from '../../../server/AppSsr';
import Button from '../../button/Button';

interface NotFoundProps {
  ssrFetchedData: AppSsrFetchedDataType;
}

const NotFound: React.FC<NotFoundProps> = ({ ssrFetchedData }) => {
  const { t } = useTranslation();
  const { navigate, toLocalizedRoute } = useAppNavigation();

  return (
    <div className="flex h-[calc(100dvh)] w-screen flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center">
        <TbError404 size={128} className="animate-bounce" />
        <span className="text-xl font-semibold">
          {t('static.not_found_page.not_found_message')}
        </span>
        <span className="mt-10">
          <Button
            label={t('static.not_found_page.go_home_button_label')}
            disabled={false}
            onClick={() => {
              navigate(toLocalizedRoute(ROUTES.HOME_ROUTE));
            }}
            data-test-id="notfound-home-button"
            id="notfound-home-button"
          />
        </span>
      </div>
    </div>
  );
};

export default NotFound;
